import React from 'react';
import LanguageSelector from './LanguageSelector';

import './Styles.scss';
import './styles.css';

export default ({ Language }) => {
  return (
    <div className="page">
      <div className="header">
        <div className="idiomContainer">
          <LanguageSelector iconType="" />
        </div>
      </div>
      <Language />
    </div>
  );
};
